import { useQuery, UseQueryResult } from '@tanstack/react-query';

import {
  AutoriteFourriereControllerApi,
  ForceOrdreControllerApi,
  SourcesImpossibiliteNotifierDto,
} from 'lib_api/lib/api/gen/api';

import { CoordonneesProprietaire } from 'components/FicheDescriptiveDisplay/CoordonneesProprietaire/types';

import { useApi } from '../ApiStoreContext';
import { useHandleBackErrors } from '../utils/handleBackErrors';

export const useComputeImpossibiliteNotifier = (
  controller: AutoriteFourriereControllerApi | ForceOrdreControllerApi,
  id: string,
  values: CoordonneesProprietaire,
): UseQueryResult<SourcesImpossibiliteNotifierDto | void> => {
  const behaviourOnError = useHandleBackErrors();

  const afController = useApi().AutoriteFourriereControllerApi;
  const foController = useApi().ForceOrdreControllerApi;

  function fetchImpossibiliteNotifier(): Promise<SourcesImpossibiliteNotifierDto | void> {
    if (controller instanceof AutoriteFourriereControllerApi) {
      return afController
        .getSourceImpossibiliteNotifierAfUsingGET(id, values)
        .catch(behaviourOnError);
    }
    return foController
      .getSourceImpossibiliteNotifierFoUsingGET(id, values)
      .catch(behaviourOnError);
  }

  return useQuery({
    queryKey: ['impossibiliteNotifier', id, values],
    queryFn: fetchImpossibiliteNotifier,
  });
};
